import { useMemo } from 'react';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';

export const useDeliveryWarningMessages = (): string[] => {
  const { data: goodsDetail } = useGoodsDetail();

  return useMemo(
    () => goodsDetail?.goods.shipping_info?.description_formatted_messages ?? [],
    [goodsDetail?.goods.shipping_info?.description_formatted_messages],
  );
};
